import { forwardRef } from 'react';

import { Button, ButtonGroup } from 'reactstrap';

import classNames from 'classnames';

import { useAggregate } from 'pages/audience/shared/hooks';
import { IJoinTypeProps } from 'types/pages/audience-builder/components/summary';
import { s } from 'utilities/strings';

import cssClasses from './join-type.module.scss';

const JoinType = forwardRef<HTMLDivElement, IJoinTypeProps>(
  ({ className, disabled = false, limit = false, onSelected, type, ...props }, ref) => {
    const { loading } = useAggregate();

    return (
      <div
        {...props}
        className={classNames(className, cssClasses.joinTypeWrapper)}
        ref={ref}>
        <ButtonGroup className="flex-grow-1">
          <Button
            active={type === 'left'}
            block
            className="p-2"
            color={type === 'left' ? 'cyan-500' : 'cyan-400'}
            data-tooltip-content="In left not in right"
            data-tooltip-id="global-tool-tip"
            disabled={disabled || limit || loading}
            onClick={() => onSelected?.('left')}
            type="button">
            <div className="d-flex flex-column">
              <div>
                <i className="fa-duotone fa-object-subtract fa-flip-both font-size-20" />
              </div>
              <div>{s(['Site.Left'])}</div>
            </div>
          </Button>
          <Button
            active={type === 'combine'}
            block
            className="p-2"
            color={type === 'combine' ? 'cyan-500' : 'cyan-400'}
            data-tooltip-content="All"
            data-tooltip-id="global-tool-tip"
            disabled={disabled || loading}
            onClick={() => onSelected?.('combine')}
            type="button">
            <div className="d flex flex-column">
              <div>
                <i className="fa-duotone fa-object-union font-size-20" />
              </div>
              <div>{s(['Site.Combine'])}</div>
            </div>
          </Button>
          <Button
            active={type === 'overlay'}
            block
            className="p-2"
            color={type === 'overlay' ? 'cyan-500' : 'cyan-400'}
            data-tooltip-content="Overlay"
            data-tooltip-id="global-tool-tip"
            disabled={disabled || loading}
            onClick={() => onSelected?.('overlay')}
            type="button">
            <div className="d flex flex-column">
              <div>
                <i className="fa-duotone fa-object-intersect font-size-20" />
              </div>
              <div>{s(['Site.Overlay'])}</div>
            </div>
          </Button>
          <Button
            active={type === 'exclude'}
            block
            className="p-2"
            color={type === 'exclude' ? 'cyan-500' : 'cyan-400'}
            data-tooltip-content="Exclude"
            data-tooltip-id="global-tool-tip"
            disabled={disabled || loading}
            onClick={() => onSelected?.('exclude')}
            type="button">
            <div className="d flex flex-column">
              <div>
                <i className="fa-duotone fa-object-exclude font-size-20" />
              </div>
              <div>{s(['Site.Exclude'])}</div>
            </div>
          </Button>
          <Button
            active={type === 'right'}
            block
            className="p-2"
            color={type === 'right' ? 'cyan-500' : 'cyan-400'}
            data-tooltip-content="In right not in left"
            data-tooltip-id="global-tool-tip"
            disabled={disabled || limit || loading}
            onClick={() => onSelected?.('right')}
            type="button">
            <div className="d flex flex-column">
              <div>
                <i className="fa-duotone fa-object-subtract font-size-20" />
              </div>
              <div>{s(['Site.Right'])}</div>
            </div>
          </Button>
        </ButtonGroup>
      </div>
    );
  }
);

JoinType.displayName = 'JoinType';

export default JoinType;
